import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function GoogleAnalytics({ measurementId }) {
  const location = useLocation();

  useEffect(() => {
    // Si no hay measurementId, no hacer nada
    if (!measurementId || measurementId === 'G-XXXXXXXXXX') {
      return;
    }

    // Cargar gtag.js
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${measurementId}`;
    document.head.appendChild(script);

    // Inicializar gtag
    window.dataLayer = window.dataLayer || [];
    function gtag() {
      window.dataLayer.push(arguments);
    }
    window.gtag = gtag;
    gtag('js', new Date());
    gtag('config', measurementId);

    return () => {
      // Cleanup script al desmontar
      const scriptElement = document.querySelector(`script[src*="${measurementId}"]`);
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, [measurementId]);

  // Track page views en cada cambio de ruta
  useEffect(() => {
    if (!measurementId || measurementId === 'G-XXXXXXXXXX' || !window.gtag) {
      return;
    }

    // Track pageview
    window.gtag('config', measurementId, {
      page_path: location.pathname + location.search,
    });
  }, [location, measurementId]);

  return null;
}

// Funciones helper para eventos personalizados
export const trackEvent = (eventName, eventParams = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, eventParams);
  }
};

// Eventos específicos para WPRescate24
export const trackFormSubmit = (formType, plan) => {
  trackEvent('form_submit', {
    form_type: formType,
    plan: plan,
  });
};

export const trackPlanView = (planName) => {
  trackEvent('view_plan', {
    plan_name: planName,
  });
};

export const trackWhatsAppClick = () => {
  trackEvent('whatsapp_click', {
    category: 'engagement',
  });
};

export const trackPhoneClick = () => {
  trackEvent('phone_click', {
    category: 'engagement',
  });
};
